/**
 * Labstep
 */

import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { ChemDrawNewReactionSvg } from 'labstep-web/core/ChemDraw/ReactionSvg';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Molecule } from 'labstep-web/models/molecule.model';
import type React from 'react';
import type {
  MoleculeStructureContainerProps,
  MoleculeStructureProps,
} from './types';

export const MoleculeStructure: React.FC<MoleculeStructureProps> = ({
  molecule,
}) => <ChemDrawNewReactionSvg svgs={[molecule.svg]} size={40} />;

/**
 * Molecule structure svg
 * Container to read svg on mount if not loaded
 */
export const MoleculeStructureContainer: React.FC<
  MoleculeStructureContainerProps
> = ({ molecule, fallback = null }) => (
  <EntityReadEntityContainer
    entityName={Molecule.entityName}
    id={molecule.idAttr}
  >
    {({ entity }): JSX.Element | null => {
      if (entity?.svg === undefined) {
        return (
          <ReadOnMountHOC
            type="entities"
            entityName={Molecule.entityName}
            params={{
              get_single: 1,
              guid: entity!.idAttr,
            }}
            loading={{ loader: 'grid_cell' }}
            children={({ entity: entityWithSvg }) =>
              entityWithSvg.svg ? (
                <MoleculeStructure molecule={entityWithSvg} />
              ) : (
                fallback
              )
            }
          />
        );
      }
      return entity.svg ? (
        <MoleculeStructure molecule={entity} />
      ) : (
        fallback
      );
    }}
  </EntityReadEntityContainer>
);
